import {view} from '@sail/ui';
import {Header} from 'src/v2/components/screen/Header';
import {Footer} from 'src/v2/components/screen/Footer';
import {isMobile} from 'src/utils/utils';

export const Layout = ({children}: {children: React.ReactNode}) => {
  const isMobileDevice = isMobile();

  return (
    <view.div
      css={{
        width: 'fill',
        height: '100dvh',
        stack: 'y',
        gapY: 'space.0',
        backgroundColor: 'white',
        overflow: 'scroll',
      }}
      data-testid="v2-layout"
    >
      <Header />

      <view.div
        css={{
          width: 'fill',
          flex: 1,
          stack: 'y',
          justifyContent: 'spaceBetween',
          alignItems: 'center',
          paddingTop: isMobileDevice ? 'large' : 'space.800',
          paddingBottom: isMobileDevice ? 'large' : 'xxlarge',
          overflowY: 'auto',
          minHeight: 'space.0',
          gapY: 'medium',
        }}
      >
        <view.div css={{width: 'fill'}} data-testid="v2-main-content">
          {children}
        </view.div>
        <Footer />
      </view.div>
    </view.div>
  );
};
